import { all, takeLatest } from "redux-saga/effects";
import {
  CART_FUNNEL_LIST,
  CART_FUNNEL_DETAILS,
  ADD_CART_FUNNEL,
  UPDATE_CART_FUNNEL,
  DELETE_CART_FUNNEL,
  EMAIL_SENDING,
} from "../actions/cart-funnel.actions.types";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { successMessage } from "../../utilities/notification";

const call = Effects.call;

function* getCartFunnelList({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "card-funnels/list",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (callback) {
    callback({
      success: !error,
      data: error ? null : result.data,
    });
  }
}

function* cartFunnelDetails({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: `card-funnels/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (callback) {
    callback({
      success: !error,
      data: error ? null : result.data,
    });
  }
}

function* addCartFunnel({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "card-funnels",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (!error) successMessage(result.message);
    callback({
      success: !error,
      data: error ? null : result.data,
    });
  }
}

function* updateCartFunnel({ payload: { id, data, callback } }) {
  const payload = {
    data,
    method: "put",
    url: `card-funnels/${id}`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (!error) successMessage(result.message);
    callback({
      success: !error,
      data: error ? null : result.data,
    });
  }
}

function* deleteCartFunnel({ payload: { id, callback } }) {
  const payload = {
    method: "delete",
    url: `card-funnels/${id}?force=false`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (!error) successMessage(result.message);
    callback({
      success: !error,
      data: error ? null : result.data,
    });
  }
}

function* sendEmail({ payload: { data, callback } }) {
  const payload = {
    data,
    method: "post",
    url: "card-funnels/send-email",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: false,
    authorization: true,
  });

  if (callback) {
    if (!error) successMessage(result.message);
    callback({
      success: !error,
      data: error ? null : result.data,
    });
  }
}

function* CartFunnel() {
  yield all([
    takeLatest(CART_FUNNEL_LIST, getCartFunnelList),
    takeLatest(CART_FUNNEL_DETAILS, cartFunnelDetails),
    takeLatest(ADD_CART_FUNNEL, addCartFunnel),
    takeLatest(UPDATE_CART_FUNNEL, updateCartFunnel),
    takeLatest(DELETE_CART_FUNNEL, deleteCartFunnel),
    takeLatest(EMAIL_SENDING, sendEmail),
  ]);
}

export default CartFunnel;
